module.exports = __webpack_public_path__ + "static/media/icon_header_back_call.542e575d.svg";